import React, { useState, useEffect } from 'react'

const TypewriterMarkdown = ({ markdownText, typingSpeed }) => {
  const [displayedText, setDisplayedText] = useState('')

  useEffect(() => {
    let charIndex = 0
    const typeInterval = setInterval(() => {
      if (charIndex < markdownText.length) {
        setDisplayedText(prev => prev + markdownText[charIndex])
        charIndex++
      } else {
        clearInterval(typeInterval) // Stop typing when the whole text is revealed
      }
    }, typingSpeed)

    return () => clearInterval(typeInterval)
  }, [markdownText, typingSpeed])

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: window.marked?.parse(displayedText),
      }}
    />
  )
}

export default TypewriterMarkdown
